<script>
import Base from "@/components/RequestDetailsForDefaultVue/ProccessInDefaultView.vue";

export default {
  name: "CustomerServiceFilesProccessInDefaultView",
  extends: Base,
};
</script>
